import {
  DueOutDiscussionsMetadata,
  DueOutDiscussionsMetadataArgs,
  getDueOutDiscussions
} from '../../assets/ts/data/dueout/dueout-discussions'
import useServerData from '../use-server-data'

function useDueoutDiscussionsMetadata(fetchArgs) {
  const {
    data: DueOutDiscussionsData,
    error: dueoutDiscussionsMetadataError,
    fetchData: fetchDueoutDiscussionsMetadata,
    isLoading: dueoutDiscussionsMetadataIsLoading,
  } = useServerData<DueOutDiscussionsMetadata, DueOutDiscussionsMetadataArgs>(
    getDueOutDiscussions,
    fetchArgs
  )

  return {
    DueOutDiscussionsData,
    dueoutDiscussionsMetadataError,
    dueoutDiscussionsMetadataIsLoading,
    fetchDueoutDiscussionsMetadata,
  }
}

export default useDueoutDiscussionsMetadata
